import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const STEPS = [
  {
    icon: null,
    title: 'Browse & Filter',
    body: 'Use the mood chips or dropdowns to find a recipe that fits your vibe — by effect, strain, or meal type.',
  },
  {
    icon: '❤️',
    title: 'Save to Your Stash',
    body: 'Tap the heart on any recipe to save it. Hit "My Stash" to pull up your saved collection anytime.',
  },
  {
    icon: null,
    title: 'Use What You Have',
    body: 'Switch to Pantry Match, type in your ingredients, and we\'ll rank every recipe by how close you can get with what\'s on hand.',
  },
];

export default function OnboardingOverlay({ onClose }) {
  const [step, setStep] = useState(0);

  const next = () => {
    if (step < STEPS.length - 1) {
      setStep(step + 1);
    } else {
      onClose();
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[100] flex items-center justify-center px-6"
      style={{ backgroundColor: 'rgba(0,0,0,0.55)' }}
      onClick={onClose}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.93, y: 16 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.93, y: 16 }}
        transition={{ duration: 0.22 }}
        className="bg-pp-white rounded-3xl shadow-2xl p-8 max-w-sm w-full text-center"
        onClick={e => e.stopPropagation()}
      >
        <AnimatePresence mode="wait">
          <motion.div
            key={step}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.18 }}
          >
            {STEPS[step].icon && <div className="text-5xl mb-4">{STEPS[step].icon}</div>}
            <h2 className="text-xl font-extrabold text-sage-900 mb-2">
              {STEPS[step].title}
            </h2>
            <p className="text-sm text-sage-900/70 leading-relaxed">
              {STEPS[step].body}
            </p>
          </motion.div>
        </AnimatePresence>

        {/* Step dots */}
        <div className="flex justify-center gap-2 mt-6 mb-5">
          {STEPS.map((_, i) => (
            <div
              key={i}
              className="w-2 h-2 rounded-full transition-all"
              style={{ backgroundColor: i === step ? 'var(--accent-bg)' : '#ccc' }}
            />
          ))}
        </div>

        <button
          onClick={next}
          className="w-full font-bold py-3 rounded-full text-white text-sm transition hover:opacity-90"
          style={{ backgroundColor: 'var(--accent-bg)' }}
        >
          {step < STEPS.length - 1 ? 'Next' : "Let's Cook"}
        </button>

        <button
          onClick={onClose}
          className="mt-3 text-xs text-sage-900/40 hover:text-sage-900/70 transition"
        >
          Skip
        </button>
      </motion.div>
    </motion.div>
  );
}
